import { useLanguage } from './LanguageProvider.jsx';
import { X } from 'lucide-react';
import { useEffect } from 'react';

export default function Modal({ title, children, onClose, wide=false }) {
  const { t } = useLanguage();
  useEffect(() => {
    const close = (event) => event.key === 'Escape' && onClose();
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, [onClose]);
  return <div className="modal-backdrop" role="presentation" onMouseDown={(event)=>event.target===event.currentTarget&&onClose()}>
    <section className={`modal ${wide?'modal--wide':''}`} role="dialog" aria-modal="true" aria-label={title}>
      <header><h2>{title}</h2><button className="icon-button" onClick={onClose} aria-label={t("common.close")}><X /></button></header>
      <div className="modal__body">{children}</div>
    </section>
  </div>;
}
